<template>
  <div class="cloud-home">
    <div class="center-line"></div>
    <div class="cloud-home-title1">
      <div class="cloud-home-title1-title">
        <img src="@/assets/images/groupTitle.png" alt="" />
        <p>省份的项目总数量</p>
        <dv-decoration-3 class="decoration-container" :style="{ width: '10%', height: '30px' }"
          style="margin-top: -35px; margin-left: 87%;">
          <!-- 插槽中添加多个小方块 -->
          <div slot="content" class="squares-container">
            <div class="square s1"></div>
            <div class="square s2"></div>
            <div class="square s3"></div>
            <div class="square s4"></div>
            <div class="square s5"></div>
            <div class="square s6"></div>
          </div>
        </dv-decoration-3>
      </div>
      <div class="cloud-home-title1-content">
        <Province :key="refreshKey" />
      </div>
    </div>

    <div class="cloud-home-title2">
      <div class="cloud-home-title2-title">
        <img src="@/assets/images/groupTitle.png" alt="" :key="refreshKey" />
        <p>隧道进度情况</p>
        <dv-decoration-3 class="decoration-container" :style="{ width: '10%', height: '30px' }"
          style="margin-top: -35px; margin-left: 87%;">
          <!-- 插槽中添加多个小方块 -->
          <div slot="content" class="squares-container">
            <div class="square s1"></div>
            <div class="square s2"></div>
            <div class="square s3"></div>
            <div class="square s4"></div>
            <div class="square s5"></div>
            <div class="square s6"></div>
          </div>
        </dv-decoration-3>
      </div>
      <div class="cloud-home-title2-content">
        <Progress :key="refreshKey" />
      </div>
    </div>

    <div class="fill-h" id="scatterMap"></div>

    <div class="cloud-home-title3">
      <div class="cloud-home-title3-title">
        <img src="@/assets/images/groupTitle.png" alt="" />
        <p>隧道预警数据</p>
        <dv-decoration-3 class="decoration-container" :style="{ width: '10%', height: '30px' }"
          style="margin-top: -35px; margin-left: 87%;">
          <!-- 插槽中添加多个小方块 -->
          <div slot="content" class="squares-container">
            <div class="square s1"></div>
            <div class="square s2"></div>
            <div class="square s3"></div>
            <div class="square s4"></div>
            <div class="square s5"></div>
            <div class="square s6"></div>
          </div>
        </dv-decoration-3>
      </div>
      <div class="cloud-home-title3-content">
        <Warning :key="refreshKey" />
      </div>
    </div>

    <div class="cloud-home-title4">
      <div class="cloud-home-title4-title">
        <img src="@/assets/images/groupTitle.png" alt="" />
        <p>隧道统计</p>
        <dv-decoration-3 class="decoration-container" :style="{ width: '10%', height: '30px' }"
          style="margin-top: -35px; margin-left: 87%; border: 0px;">
          <!-- 插槽中添加多个小方块 -->
          <div slot="content" class="squares-container">
            <div class="square s1"></div>
            <div class="square s2"></div>
            <div class="square s3"></div>
            <div class="square s4"></div>
            <div class="square s5"></div>
            <div class="square s6"></div>
          </div>
        </dv-decoration-3>
      </div>
      <div class="cloud-home-title4-content">
        <Personnel :key="refreshKey" />
      </div>
    </div>
  </div>
</template>

<script>
import Province from '@/pages/mainpage/components/home/Province.vue'
import Progress from '@/pages/mainpage/components/home/Progress.vue'
import Warning from '@/pages/mainpage/components/home/Warning.vue'
import Personnel from '@/pages/mainpage/components/home/Personnel.vue'
import chinaMap from "@/assets/map/china.json";
import * as echarts from 'echarts';
import { getstatisticsTunnelCount } from '@/public/api.js'
import city from "@/utils/city.json";
import { ProvinceData } from './components/testData/ProvinceData'

// 引入路由实例
export default {
  name: 'loginpage',
  components: {
    Province,
    Progress,
    Warning,
    Personnel,
  },
  data() {
    return {
      scatterValData: [],
      scatterGeo: {},
      FormData: {
        environment: 0,
        worker: 0,
        car: 0,
        pace: 0,
        environmentDay: 0,
        workerDay: 0,
        carDay: 0,
        paceDay: 0,
        tunnel: 0,
        tunnelNum: 0,
      },
      nationalTunnelList: [],
      tunnelList: [],
      refreshKey: 0,
    }
  },
  computed: {

  },
  mounted() {
    let that = this;
    let hostName = window.location.hostname;

    if (hostName == '127.0.0.1' || hostName == '39.100.79.198' || hostName == 'sd.yongsixinxi.com') {
      ProvinceData().forEach(item => {
        city.forEach(itemCity => {
          if (itemCity.value === item.provinceId) {
            that.nationalTunnelList.push({
              name: itemCity.label,
              num: item.count,
              provinceId: item.provinceId
            })
          }
        })

      })
      that.initCharts(ProvinceData());
    } else {
      this.StatisticsTunnelCount()
    }

  },
  methods: {
    // 统计隧道数量
    StatisticsTunnelCount() {
      let that = this;
      getstatisticsTunnelCount({

      }).then(res => {
        if (res.data.code == 200) {
          let dataDom = res.data.data;

          dataDom.forEach(item => {
            city.forEach(itemCity => {
              if (itemCity.value === item.provinceId) {
                that.nationalTunnelList.push({
                  name: itemCity.label,
                  num: item.count,
                  provinceId: item.provinceId
                })
              }
            })

          })
          that.initCharts(dataDom);
        }


      })
    },
    initCharts(dataDom) {
      //初始化echarts实例
      echarts.registerMap("china", { geoJSON: chinaMap });
      const chartDom = document.getElementById('scatterMap');
      const myChart = echarts.init(chartDom);
      // 新增：存储省份对应的数值（用于地图标签显示）
      let provinceValueMap = {};
      let data = [];
      let LableData = [];

      let iconRQ = "image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAUCAYAAABiS3YzAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjNCRkRBMEJBQzgwRjExRUFBNUI0RTMyMThEN0UxMzFEIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjNCRkRBMEJCQzgwRjExRUFBNUI0RTMyMThEN0UxMzFEIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6M0JGREEwQjhDODBGMTFFQUE1QjRFMzIxOEQ3RTEzMUQiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6M0JGREEwQjlDODBGMTFFQUE1QjRFMzIxOEQ3RTEzMUQiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5mT42iAAABQ0lEQVR42mL8LabOQCQIBOL1xChkItJAkLp+IBajpqFWQCwPxJ7UNDQCSgdQy1BmIA6Bsl2AmJMahjoAsTiUzQPETtQwNAKN709IAwvUayZQ/hcg/o0k/x6Ig9D0+ABxKJT9HYh/oMm/BBm6GYitgTgfiBmJcLkkEK/CIXcGiGNB3v8JxIVQF31gIA/8AeIWaNK7gRymG4BYH4hPkGjgXSC2A+JaWNChR9QjqIJeIP5PhIGzgdgAiI8Tin2QbSVAvIOAgROBOA0auUQlKV4gtidgqBGp6RSUFrmIKA/ESDEUPcGfBOIUIH6Lln29iTVUCIjdkJJKExDbAPFcqJdPEMpd2AwF5TBWaFKxBeJ6qOHIqaMbmjrcsBUw2AwNh7rKAEeaBaWOMiD2BeJvQOxOyFBuaFJJwZZU0MBWaHCIo0sABBgAetA4Jx5t/ToAAAAASUVORK5CYII="

      dataDom.forEach(item => {
        city.forEach(itemCity => {
          if (itemCity.value === item.provinceId) {
            chinaMap.features.forEach(itemMap => {

              const provinceName = itemCity.label.replace('省', '');

              if (itemMap.properties.name === provinceName) {
                data.push({
                  name: provinceName,
                  value: itemMap.properties.center
                })
                let value = [];
                value.push(0);
                value.push(item.count);

                let coords = [];
                coords.push(itemMap.properties.center);
                coords.push(itemMap.properties.center);

                LableData.push({
                  name: provinceName,
                  coords: coords,
                  value: value,
                  provinceId: item.provinceId
                })
                // 关键：存储省份名称对应的数值（隧道数量/工地数量）
                provinceValueMap[provinceName] = {
                  tunnelCount: item.count, // 隧道数量
                  siteCount: 0 // 工地数量（根据实际数据修改，这里默认0）
                };
              }
            })
          }
        })
      })

      let option = {
        geo: {
          map: 'china',
          aspectScale: 0.85,
          layoutCenter: ["50%", "50%"], //地图位置
          layoutSize: '100%',
          itemStyle: {
            normal: {
              shadowColor: '#276fce',
              shadowOffsetX: 0,
              shadowOffsetY: 15,
              opacity: 0.5,
            },
            emphasis: {
              areaColor: '#276fce',
            }
          },
          regions: [{
            name: '南海诸岛',
            itemStyle: {
              areaColor: 'rgba(0, 10, 52, 1)',
              borderColor: 'rgba(0, 10, 52, 1)',
              normal: {
                opacity: 0,
                label: {
                  show: false,
                  color: "#009cc9",
                }
              },
            },
            label: {
              show: false,
              color: '#FFFFFF',
              fontSize: 12,
            },
          }],
        },
        series: [
          // 常规地图
          {
            type: 'map',
            mapType: 'china',
            aspectScale: 0.85,
            layoutCenter: ["50%", "50%"], //地图位置
            layoutSize: '100%',
            zoom: 1, //当前视角的缩放比例
            // roam: true, //是否开启平游或缩放
            scaleLimit: { //滚轮缩放的极限控制
              min: 1,
              max: 2
            },
            itemStyle: {
              normal: {
                areaColor: '#0c274b',
                borderColor: '#1cccff',
                borderWidth: 1.5
              },
              emphasis: {
                areaColor: '#02102b',
                label: {
                  color: "#fff"
                }
              }
            },
            // 关键修改1：启用省份标签
            label: {
              normal: {
                show: true, // 默认显示标签
                color: '#ff8003', // 数字颜色（与散点图一致）
                fontSize: 12, // 字体大小
                fontWeight: 'bold', // 加粗
                // 关键修改2：格式化标签内容（显示省份名称+数字）
                formatter: function (params) {
                  const provinceData = provinceValueMap[params.name];
                  // 显示格式：省份名称 + 隧道数量（可根据需求调整）
                  return `${params.name}\n${provinceData ? provinceData.tunnelCount + '条' : ''}`;
                }
              },
              emphasis: {
                show: true,
                color: '#fff', // 鼠标悬浮时标签颜色
                fontSize: 14 // 悬浮时放大字体
              }
            }
          },
          { //首都星图标
            name: '首都',
            type: 'scatter',
            coordinateSystem: 'geo',
            data: [{
              name: '首都',
              value: [116.24, 41.55, 100],

            },],
            symbol: iconRQ,
            symbolSize: 20,
            label: {
              normal: {
                show: false,
              },
              emphasis: {
                show: false
              }
            },
          },
          // 区域散点图
          // {
          //   type: 'effectScatter',
          //   coordinateSystem: 'geo',
          //   zlevel: 2,
          //   symbolSize: 10,
          //   rippleEffect: { //坐标点动画
          //     period: 3,
          //     scale: 5,
          //     brushType: 'fill'
          //   },
          //   label: {
          //     normal: {
          //       show: false,
          //       position: 'right',
          //       color: '#b3e2f2',
          //       fontWeight: "bold",
          //       fontSize: 10
          //     }
          //   },
          //   data: data,
          //   itemStyle: { //坐标点颜色
          //     normal: {
          //       show: true,
          //       color: '#ff8003',
          //       shadowBlur: 20,
          //       shadowColor: '#fff'
          //     },
          //     emphasis: {
          //       areaColor: '#f00'
          //     }
          //   },
          // },
          // {
          //   type: 'lines',
          //   zlevel: 3,
          //   symbol: 'circle',
          //   symbolSize: [5, 5],
          //   color: '#ff8003',
          //   opacity: 1,
          //   label: {
          //     normal: {
          //       show: false, // 默认不显示
          //       padding: [10, 20],
          //       color: '#fff',
          //       backgroundColor: "#1a3961",
          //       borderColor: '#aee9fb',
          //       borderWidth: 1,
          //       borderRadius: 6,
          //       formatter(params) {
          //         let arr = [params.name, "隧道数量：" + params.value[1] + "条", "工地数量：" + params.value[0] + "条"];
          //         return arr.join("\n")
          //       },
          //       textStyle: {
          //         align: 'left',
          //         lineHeight: 20,
          //       }
          //     },
          //     emphasis: {
          //       show: true // 鼠标悬停时显示
          //     }
          //   },
          //   lineStyle: {
          //     type: 'solid',
          //     color: '#fff',
          //     width: 0.5,
          //     opacity: 1,
          //   },
          //   data: LableData,
          // }
        ]
      };


      //渲染报表
      myChart.setOption(option);

      let that = this;
      // 添加点击事件监听    
      myChart.on('click', function (params) {

        localStorage.setItem('provinceId', params.data.provinceId);
        // 判断点击的是否是lines系列的label        
        // if (params.seriesType === 'lines' && params.componentType === 'series') {
        that.$router.push({
          path: '/detail',
        });
        // }
      });
    },
  },
  beforeDestroy() {

  }
}
</script>
<style scoped>
.cloud-home {
  position: relative;
  top: 1%;
  left: 10px;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
  /* 确保溢出的内容被隐藏 */
}

.cloud-home>.cloud-home-title1 {
  position: absolute;
  top: 1vh;
  left: 0;
  width: calc(400 / 1920 * 100vw);
  height: calc(410 / 1080 * 100vh);
  background: rgba(0, 0, 0, 0.4);
  border-radius: 10px;

  .cloud-home-title1-title {
    position: relative;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 2.5vh;
    margin: 0;
    padding: 0;

    img {
      width: 100%;
      height: auto;
      margin: 0;
      padding: 0;
    }

    p {
      position: absolute;
      top: 0.3vh;
      left: 3.01vh;
      width: 100%;
      height: 2.5vh;
      margin: 0;
      padding: 0;
      font-size: 1.0rem;
      color: #fff;
      text-align: left;
    }
  }

  .cloud-home-title1-content {
    position: relative;
    top: 0px;
    left: 0px;
    width: 93%;
    height: calc(350 / 1080 * 100vh);
    margin: 0;
    padding: 10px;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: rgba(150, 150, 150, 0.2) transparent;
  }
}

.cloud-home>.cloud-home-title2 {
  position: absolute;
  top: calc(430 / 1080 * 100vh);
  left: 0;
  width: calc(400 / 1920 * 100vw);
  height: calc(460 / 1080 * 100vh);
  background: rgba(0, 0, 0, 0.4);
  border-radius: 10px;

  .cloud-home-title2-title {
    position: relative;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 2.5vh;
    margin: 0;
    padding: 0;

    img {
      width: 100%;
      height: auto;
      margin: 0;
      padding: 0;
    }

    p {
      position: absolute;
      top: 0.3vh;
      left: 3.01vh;
      width: 100%;
      height: 2.5vh;
      margin: 0;
      padding: 0;
      font-size: 1.0rem;
      color: #fff;
      text-align: left;
    }
  }

  .cloud-home-title2-content {
    position: relative;
    top: 0px;
    left: 0px;
    width: 100%;
    height: calc(430 / 1080 * 100vh);
    margin: 0;
    padding: 10px;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: rgba(150, 150, 150, 0.2) transparent;
  }
}

.cloud-home>.cloud-home-title3 {
  position: absolute;
  top: 1vh;
  right: 1%;
  width: calc(400 / 1920 * 100vw);
  height: calc(410 / 1080 * 100vh);
  background: rgba(0, 0, 0, 0.4);
  border-radius: 10px;

  .cloud-home-title3-title {
    position: relative;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 2.5vh;
    margin: 0;
    padding: 0;

    img {
      width: 100%;
      height: auto;
      margin: 0;
      padding: 0;
    }

    p {
      position: absolute;
      top: 0.3vh;
      left: 3.01vh;
      width: 100%;
      height: 2.5vh;
      margin: 0;
      padding: 0;
      font-size: 1.0rem;
      color: #fff;
      text-align: left;
    }
  }

  .cloud-home-title3-content {
    position: relative;
    top: 0px;
    left: 0px;
    width: 94%;
    height: calc(430 / 1080 * 100vh);
    margin: 0;
    padding: 10px;
    overflow-y: hidden;
    scrollbar-width: thin;
    scrollbar-color: rgba(150, 150, 150, 0.2) transparent;
  }
}

.cloud-home>.cloud-home-title4 {
  position: absolute;
  top: calc(430 / 1080 * 100vh);
  right: 1%;
  width: calc(400 / 1920 * 100vw);
  height: calc(460 / 1080 * 100vh);
  background: rgba(0, 0, 0, 0.4);
  border-radius: 10px;

  .cloud-home-title4-title {
    position: relative;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 2.5vh;
    margin: 0;
    padding: 0;

    img {
      width: 100%;
      height: auto;
      margin: 0;
      padding: 0;
    }

    p {
      position: absolute;
      top: 0.3vh;
      left: 3.01vh;
      width: 100%;
      height: 2.5vh;
      margin: 0;
      padding: 0;
      font-size: 1.0rem;
      color: #fff;
      text-align: left;
    }
  }

  .cloud-home-title4-content {
    position: relative;
    top: 0px;
    left: 0px;
    width: 94%;
    height: calc(420 / 1080 * 100vh);
    margin: 0;
    padding: 10px;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: rgba(150, 150, 150, 0.2) transparent;
  }

  
}

.fill-h {
  width: 80%;
  padding: 3%;
  height: 860px;
  margin: 0 auto;
  z-index: 1000;
}
</style>